// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"styles_breadcrumb__1lS6h","list":"styles_list__1vw-x","item":"styles_item__2vLYr","active":"styles_active__2AK14"};